// extracted by mini-css-extract-plugin
module.exports = {"BookList":"BookList_BookList__1Q1Q0","Content":"BookList_Content__14LpG"};